module.exports = __webpack_public_path__ + "img/icon-qsls.2e2db9af.png";